export const sortKeys = [
  {
    text: 'Recommended',
    code: 'sortBy=position&sortDir=ASC',
    shortCode: 'position-ASC',
  },
  {
    text: 'LowestPrice',
    code: 'sortBy=price&sortDir=ASC',
    shortCode: 'price-ASC',
  },
  {
    text: 'HighestPrice',
    code: 'sortBy=price&sortDir=DESC',
    shortCode: 'price-DESC',
  },
  {
    text: 'HighestDiscount',
    code: 'sortBy=special_price&sortDir=DESC',
    shortCode: 'special_price-DESC',
  },
  // {
  //   text: "LowerDiscount",
  //   code: "sortBy=special_price&sortDir=ASC",
  // },
];
